// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__dTf11","inner":"Header_inner__jb7a0"};